import React from 'react';
import EcoSectionCard from 'eco-design-components/sections/eco-section-card';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useProductStore } from 'elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from 'elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';

interface IPowerOceanAProps {
    productName?: 'AcPro' | 'Ultra';
}
const PowerOceanA: React.FC<IPowerOceanAProps> = ({ productName }) => {
    const { t } = useLang('theProduct.PowerOceanA');
    const { locale } = getLocal();
    const { pageStatus } = useProductStore();
    const urlMap: any = {
        AcPro: `https://homebattery.ecoflow.com/${locale}`,
        Ultra: `https://homebattery.ecoflow.com/${locale}`,
    };

    return (
        <section className={`${styles.PowerOceanA} GtmModuleData-section`} data-section-id="PowerOceanA" data-section-title={t('title')}>
            <EcoSectionCard
                lChildren={t('btntext')}
                lHref={urlMap[productName as string] || `https://homebattery.ecoflow.com/${locale}/home-energy-ecosystem`}
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: 'Inpage',
                    button_name: t('btntext'),
                    url: urlMap[productName as string] || `https://homebattery.ecoflow.com/${locale}/home-energy-ecosystem`,
                }}
                title={t('title')}
                lRadius="ellipse"
                desc={t('desc')}
                className="powerocean-card"
                pc="https://websiteoss.ecoflow.com/upload/image/1742554758246/pc-powerocean-bg.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1742554758246/pc-powerocean-bg.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1743596235594/m-power-ocean1.png"
                imgHeight="16-9"
            />
        </section>
    );
};

export default PowerOceanA;
